import { Logger } from "../../utils/Logger";
import { Modal } from "./Modal";

export type PortfolioModalPayload = {
  logoUrl: string;
  companyName: string;
  industry: string;
  projectYear: number | null;
  keyTasks: string;
};

const DASH = "—";

/** 줄바꿈·쉼표(,)·전각쉼표(，) 기준으로 항목 분리 — 공백 트림 */
function tokenizeKeyTasks(raw: string): string[] {
  const text = raw.replace(/\r\n/g, "\n").trim();
  if (text === "") {
    return [];
  }
  const out: string[] = [];
  for (const segment of text.split("\n")) {
    const line = segment.trim();
    if (line === "") {
      continue;
    }
    for (const piece of line.split(/[,，]/)) {
      const t = piece.trim();
      if (t !== "") {
        out.push(t);
      }
    }
  }
  return out;
}

export class PortfolioModal extends Modal {
  private readonly logoEl: HTMLImageElement | null;
  private readonly logoWrap: HTMLElement | null;
  private readonly companyEl: HTMLElement | null;
  private readonly industryEl: HTMLElement | null;
  private readonly yearEl: HTMLElement | null;
  private readonly tasksEl: HTMLElement | null;

  public constructor(root: HTMLElement | string) {
    super(root);
    this.logoEl = this.root.querySelector<HTMLImageElement>("[data-bro-portfolio-modal-logo]");
    this.logoWrap = this.root.querySelector<HTMLElement>(".bro-portfolio-modal__logo-wrap");
    this.companyEl = this.root.querySelector<HTMLElement>("[data-bro-portfolio-modal-company]");
    this.industryEl = this.root.querySelector<HTMLElement>("[data-bro-portfolio-modal-industry]");
    this.yearEl = this.root.querySelector<HTMLElement>("[data-bro-portfolio-modal-year]");
    this.tasksEl = this.root.querySelector<HTMLElement>("[data-bro-portfolio-modal-tasks]");
    this.bindDefaultClose();
    this.bindOpeners();
  }

  private bindOpeners(): void {
    document.querySelectorAll<HTMLElement>("[data-bro-portfolio-open]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const raw = btn.getAttribute("data-portfolio");
        if (!raw) return;
        try {
          const data = JSON.parse(raw) as PortfolioModalPayload;
          this.fill(data);
          this.open();
        } catch (e) {
          Logger.error("PortfolioModal parse", e);
        }
      });
    });
  }

  private fill(data: PortfolioModalPayload): void {
    const logo = (data.logoUrl ?? "").trim();
    if (this.logoEl) {
      this.logoEl.src = logo === "" ? "data:," : logo;
      this.logoEl.alt = data.companyName ? `${data.companyName} logo` : "";
    }
    if (this.logoWrap) {
      this.logoWrap.classList.toggle("bro-portfolio-modal__logo-wrap--empty", logo === "");
    }

    if (this.companyEl) {
      this.companyEl.textContent = (data.companyName ?? "").trim() || DASH;
    }
    if (this.industryEl) {
      this.industryEl.textContent = (data.industry ?? "").trim() || DASH;
    }
    if (this.yearEl) {
      const y = data.projectYear;
      this.yearEl.textContent = y !== null && y !== undefined && !Number.isNaN(Number(y)) ? String(y) : DASH;
    }
    if (this.tasksEl) {
      this.tasksEl.innerHTML = "";
      const items = tokenizeKeyTasks(data.keyTasks ?? "");
      if (items.length === 0) {
        const p = document.createElement("p");
        p.className = "bro-portfolio-modal__tasks-empty";
        p.textContent = DASH;
        this.tasksEl.appendChild(p);
      } else {
        const ul = document.createElement("ul");
        ul.className = "bro-portfolio-modal__tasks-list";
        for (const line of items) {
          const li = document.createElement("li");
          li.textContent = line;
          ul.appendChild(li);
        }
        this.tasksEl.appendChild(ul);
      }
    }
  }
}
